import { render } from "./MenuBarGroupItem.vue?vue&type=template&id=02a8623a&scoped=true"
import script from "./MenuBarGroupItem.vue?vue&type=script&lang=js"
export * from "./MenuBarGroupItem.vue?vue&type=script&lang=js"

import "./MenuBarGroupItem.vue?vue&type=style&index=0&id=02a8623a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02a8623a"]])

export default __exports__